// No images - empty placeholders
export const heroImages = {
  img1: "",
  img2: "",
};

export const projectImages = {
  project1: {
    img1: "",
    img2: "",
  },
  project2: {
    img1: "",
    img2: "",
  },
  project3: {
    img1: "",
    img2: "",
  },
  project4: {
    img1: "",
    img2: "",
  },
  project5: {
    img1: "",
    img2: "",
  },
  project6: {
    img1: "",
    img2: "",
  },
  project7: {
    img1: "",
    img2: "",
  },
  project8: {
    img1: "",
    img2: "",
  },
};

